import React from 'react';
import { formatINR } from '../checkout/formatINR';

/**
 * Progress toward free delivery threshold (cart / checkout).
 */
export function freeShippingProgress(subtotal, rules) {
  const freeAbove = Number(rules?.free_above_inr) || 0;
  if (freeAbove <= 0) return null;
  const merchandise = Math.max(0, Number(subtotal) || 0);
  if (merchandise >= freeAbove) {
    return { qualified: true, freeAbove, merchandise };
  }
  return { qualified: false, freeAbove, merchandise, remaining: freeAbove - merchandise };
}

export default function FreeShippingNudge({ subtotal, rules, className = '' }) {
  const progress = freeShippingProgress(subtotal, rules);
  if (!progress) return null;

  const pct = progress.qualified
    ? 100
    : Math.min(100, Math.round((progress.merchandise / progress.freeAbove) * 100));

  return (
    <div className={`free-shipping-nudge ${className}`.trim()} role="status">
      {progress.qualified ? (
        <p className="free-shipping-nudge__text free-shipping-nudge__text--done mb-0">
          You qualify for <strong>free delivery</strong> on this order.
        </p>
      ) : (
        <>
          <p className="free-shipping-nudge__text mb-2">
            Add <strong>{formatINR(progress.remaining)}</strong> more for free delivery
          </p>
          <div className="free-shipping-nudge__track" aria-hidden>
            <span className="free-shipping-nudge__fill" style={{ width: `${pct}%` }} />
          </div>
        </>
      )}
    </div>
  );
}
